'use strict';

import angular from 'angular';
import resources from '../resources';

import UserModel from './user_model';

const dependencies = [
  resources
];

export default angular
  .module('models', dependencies)
  .service('userModel', UserModel)
  .name;



// WEBPACK FOOTER //
// ./app/src/models/index.js